/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateEncountersFilesBody,
  CreateFileErrorResponse,
  CreateFileResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncountersFiles = (
  encounterId: number,
  createEncountersFilesBody: CreateEncountersFilesBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, createEncountersFilesBody.file);

  return api<CreateFileResponse>({
    url: `/api/encounters/${encounterId}/files`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCreateEncountersFilesMutationOptions = <
  TError = CreateFileErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersFiles>>,
    TError,
    { encounterId: number; data: CreateEncountersFilesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersFiles>>,
  TError,
  { encounterId: number; data: CreateEncountersFilesBody },
  TContext
> => {
  const mutationKey = ['createEncountersFiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersFiles>>,
    { encounterId: number; data: CreateEncountersFilesBody }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersFiles(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersFiles>>
>;
export type CreateEncountersFilesMutationBody = CreateEncountersFilesBody;
export type CreateEncountersFilesMutationError = CreateFileErrorResponse;

export const useCreateEncountersFiles = <TError = CreateFileErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersFiles>>,
      TError,
      { encounterId: number; data: CreateEncountersFilesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersFiles>>,
  TError,
  { encounterId: number; data: CreateEncountersFilesBody },
  TContext
> => {
  const mutationOptions = getCreateEncountersFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
